module.exports = [
	{
		"id": 1,
		"iso": "RU",
		"name": "Россия",
		"original_name": "Russia",
		"is_european_union": "0",
		"order": 1,
		"latitude": "55.75690500",
		"longitude": "37.61490300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 10,
		"iso": "BY",
		"name": "Белоруссия",
		"original_name": "Беларусь",
		"is_european_union": "0",
		"order": 3,
		"latitude": "53.90225700",
		"longitude": "27.56183100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 5,
		"iso": "KZ",
		"name": "Казахстан",
		"original_name": "Қазақстан",
		"is_european_union": "0",
		"order": 4,
		"latitude": "51.12339500",
		"longitude": "71.42761000",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 26,
		"iso": "AU",
		"name": "Австралия",
		"original_name": "Australia",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-35.30653600",
		"longitude": "149.12654500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 39,
		"iso": "AT",
		"name": "Австрия",
		"original_name": "Österreich",
		"is_european_union": "1",
		"order": 5,
		"latitude": "48.20253600",
		"longitude": "16.36879600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 19,
		"iso": "AZ",
		"name": "Азербайджан",
		"original_name": "Azərbaycan",
		"is_european_union": "0",
		"order": 5,
		"latitude": "40.36914700",
		"longitude": "49.83473200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 111,
		"iso": "AL",
		"name": "Албания",
		"original_name": "Republika e Shqipërisë",
		"is_european_union": "0",
		"order": 5,
		"latitude": "41.32231900",
		"longitude": "19.82514500",
		"date_created": "2016-09-22 11:20:46",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 27,
		"iso": "AR",
		"name": "Аргентина",
		"original_name": "Argentina",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-36.67447400",
		"longitude": "-60.55796700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 57,
		"iso": "AM",
		"name": "Армения",
		"original_name": "Հայաստան",
		"is_european_union": "0",
		"order": 5,
		"latitude": "40.17764200",
		"longitude": "44.51259100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 78,
		"iso": "BZ",
		"name": "Белиз",
		"original_name": "Belize",
		"is_european_union": "0",
		"order": 5,
		"latitude": "17.25413500",
		"longitude": "-88.77041100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 44,
		"iso": "BE",
		"name": "Бельгия",
		"original_name": "Belgien",
		"is_european_union": "1",
		"order": 5,
		"latitude": "50.84438800",
		"longitude": "4.35608400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 79,
		"iso": "BM",
		"name": "Бермуды",
		"original_name": "Bermudas",
		"is_european_union": "0",
		"order": 5,
		"latitude": "32.29361500",
		"longitude": "-64.78413600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 29,
		"iso": "BG",
		"name": "Болгария",
		"original_name": "България",
		"is_european_union": "1",
		"order": 5,
		"latitude": "42.69717700",
		"longitude": "23.32430700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 112,
		"iso": "BA",
		"name": "Босния и Герцеговина",
		"original_name": "Bosna i Hercegovina",
		"is_european_union": "0",
		"order": 5,
		"latitude": "43.85941900",
		"longitude": "18.43575600",
		"date_created": "2016-09-22 11:20:46",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 13,
		"iso": "BR",
		"name": "Бразилия",
		"original_name": "Brasil",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-15.77842400",
		"longitude": "-47.92864200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 34,
		"iso": "HU",
		"name": "Венгрия",
		"original_name": "Magyarország",
		"is_european_union": "1",
		"order": 5,
		"latitude": "47.49971500",
		"longitude": "19.05507300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 46,
		"iso": "VN",
		"name": "Вьетнам",
		"original_name": "Việt Nam",
		"is_european_union": "0",
		"order": 5,
		"latitude": "21.02891700",
		"longitude": "105.85461600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 56,
		"iso": "HT",
		"name": "Гаити",
		"original_name": "Haiti",
		"is_european_union": "0",
		"order": 5,
		"latitude": "18.54473000",
		"longitude": "-72.33510500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 71,
		"iso": "_basque-country",
		"name": "Гваделупа",
		"original_name": "Guadeloupe",
		"is_european_union": "0",
		"order": 5,
		"latitude": "15.99868200",
		"longitude": "-61.73433700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 8,
		"iso": "DE",
		"name": "Германия",
		"original_name": "Deutschland",
		"is_european_union": "1",
		"order": 5,
		"latitude": "52.50877900",
		"longitude": "13.37027700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 80,
		"iso": "HN",
		"name": "Гондурас",
		"original_name": "Honduras",
		"is_european_union": "0",
		"order": 5,
		"latitude": "14.08189700",
		"longitude": "-87.20539400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 81,
		"iso": "HK",
		"name": "Гонконг",
		"original_name": "香港",
		"is_european_union": "0",
		"order": 5,
		"latitude": "22.28331400",
		"longitude": "114.15871500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 48,
		"iso": "GR",
		"name": "Греция",
		"original_name": "Ελλάδα",
		"is_european_union": "1",
		"order": 5,
		"latitude": "37.97612400",
		"longitude": "23.73642700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 20,
		"iso": "GE",
		"name": "Грузия",
		"original_name": "საქართველოს",
		"is_european_union": "0",
		"order": 5,
		"latitude": "41.69704800",
		"longitude": "44.79930700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 52,
		"iso": "DK",
		"name": "Дания",
		"original_name": "Danmark",
		"is_european_union": "1",
		"order": 5,
		"latitude": "55.67566600",
		"longitude": "12.56755700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 84,
		"iso": "DO",
		"name": "Доминиканская Республика",
		"original_name": "La República Dominicana",
		"is_european_union": "0",
		"order": 5,
		"latitude": "18.47184900",
		"longitude": "-69.89138200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 51,
		"iso": "EG",
		"name": "Египет",
		"original_name": "مصر",
		"is_european_union": "0",
		"order": 5,
		"latitude": "30.04990300",
		"longitude": "31.24859800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 24,
		"iso": "IL",
		"name": "Израиль",
		"original_name": "ישראל",
		"is_european_union": "0",
		"order": 5,
		"latitude": "31.78000200",
		"longitude": "35.21881900",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 9,
		"iso": "IN",
		"name": "Индия",
		"original_name": "भारत",
		"is_european_union": "0",
		"order": 5,
		"latitude": "28.63614000",
		"longitude": "77.21370500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 99,
		"iso": "ID",
		"name": "Индонезия",
		"original_name": "Indonesia",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-6.20842100",
		"longitude": "106.83917900",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 98,
		"iso": "JO",
		"name": "Иордания",
		"original_name": "الأردن",
		"is_european_union": "0",
		"order": 5,
		"latitude": "31.95179800",
		"longitude": "35.94041800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 65,
		"iso": "IQ",
		"name": "Ирак",
		"original_name": "العراق",
		"is_european_union": "0",
		"order": 5,
		"latitude": "33.34208900",
		"longitude": "44.39307900",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 45,
		"iso": "IR",
		"name": "Иран",
		"original_name": "ایران",
		"is_european_union": "0",
		"order": 5,
		"latitude": "35.68876500",
		"longitude": "51.41502100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 58,
		"iso": "IE",
		"name": "Ирландия",
		"original_name": "Éire",
		"is_european_union": "1",
		"order": 5,
		"latitude": "53.34806900",
		"longitude": "-6.24826800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 110,
		"iso": "IS",
		"name": "Исландия",
		"original_name": "Ísland",
		"is_european_union": "0",
		"order": 5,
		"latitude": "64.14740900",
		"longitude": "-21.93398500",
		"date_created": "2016-09-22 11:20:46",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 22,
		"iso": "ES",
		"name": "Испания",
		"original_name": "España",
		"is_european_union": "1",
		"order": 5,
		"latitude": "40.42027500",
		"longitude": "-3.70576600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 16,
		"iso": "IT",
		"name": "Италия",
		"original_name": "Italia",
		"is_european_union": "1",
		"order": 5,
		"latitude": "41.90321900",
		"longitude": "12.49564600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 61,
		"iso": "CM",
		"name": "Камерун",
		"original_name": "Cameroon",
		"is_european_union": "0",
		"order": 5,
		"latitude": "3.84683300",
		"longitude": "11.52044400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 14,
		"iso": "CA",
		"name": "Канада",
		"original_name": "Canada",
		"is_european_union": "0",
		"order": 5,
		"latitude": "45.42177600",
		"longitude": "-75.69118300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 60,
		"iso": "CY",
		"name": "Кипр",
		"original_name": "Κύπρος",
		"is_european_union": "1",
		"order": 5,
		"latitude": "35.18267000",
		"longitude": "33.36085100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 18,
		"iso": "KG",
		"name": "Киргизия",
		"original_name": "Kyrgyzstan",
		"is_european_union": "0",
		"order": 5,
		"latitude": "42.87598900",
		"longitude": "74.60367400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 30,
		"iso": "CN",
		"name": "Китай",
		"original_name": "中國",
		"is_european_union": "0",
		"order": 5,
		"latitude": "39.91386700",
		"longitude": "116.37653800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 74,
		"iso": "KP",
		"name": "Корея",
		"original_name": "한국",
		"is_european_union": "0",
		"order": 5,
		"latitude": "39.03490400",
		"longitude": "125.74045100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 59,
		"iso": "CR",
		"name": "Коста-Рика",
		"original_name": "Costa Rica",
		"is_european_union": "0",
		"order": 5,
		"latitude": "9.92974400",
		"longitude": "-84.08568800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 96,
		"iso": "CU",
		"name": "Куба",
		"original_name": "Cuba",
		"is_european_union": "0",
		"order": 5,
		"latitude": "23.13210800",
		"longitude": "-82.36749000",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 75,
		"iso": "KW",
		"name": "Кувейт",
		"original_name": "الكويت",
		"is_european_union": "0",
		"order": 5,
		"latitude": "29.33588100",
		"longitude": "47.59547500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 23,
		"iso": "LV",
		"name": "Латвия",
		"original_name": "Latvija",
		"is_european_union": "1",
		"order": 5,
		"latitude": "56.94804800",
		"longitude": "24.10701800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 76,
		"iso": "LB",
		"name": "Ливан",
		"original_name": "لبنان",
		"is_european_union": "0",
		"order": 5,
		"latitude": "33.89606400",
		"longitude": "35.50677400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 72,
		"iso": "LY",
		"name": "Ливия",
		"original_name": "ليبيا",
		"is_european_union": "0",
		"order": 5,
		"latitude": "32.89533500",
		"longitude": "13.18104300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 17,
		"iso": "LT",
		"name": "Литва",
		"original_name": "Lietuva",
		"is_european_union": "1",
		"order": 5,
		"latitude": "54.69061600",
		"longitude": "25.26979800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 113,
		"iso": "LI",
		"name": "Лихтенштейн",
		"original_name": "Fürstentum Liechtenstein",
		"is_european_union": "0",
		"order": 5,
		"latitude": "47.13878700",
		"longitude": "9.52163900",
		"date_created": "2016-09-22 11:20:46",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 83,
		"iso": "LU",
		"name": "Люксембург",
		"original_name": "Luxembourg",
		"is_european_union": "1",
		"order": 5,
		"latitude": "49.61682500",
		"longitude": "6.12712600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 100,
		"iso": "MK",
		"name": "Македония",
		"original_name": "Македонија",
		"is_european_union": "0",
		"order": 5,
		"latitude": "41.99473600",
		"longitude": "21.42998500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 101,
		"iso": "MY",
		"name": "Малайзия",
		"original_name": "Malaysia",
		"is_european_union": "0",
		"order": 5,
		"latitude": "3.14775200",
		"longitude": "101.69401500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 105,
		"iso": "MT",
		"name": "Мальта",
		"original_name": "Malta",
		"is_european_union": "1",
		"order": 5,
		"latitude": "35.89352900",
		"longitude": "14.51177100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 70,
		"iso": "MA",
		"name": "Марокко",
		"original_name": "مغربي",
		"is_european_union": "0",
		"order": 5,
		"latitude": "34.01789400",
		"longitude": "-6.83612500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 11,
		"iso": "MX",
		"name": "Мексика",
		"original_name": "México",
		"is_european_union": "0",
		"order": 5,
		"latitude": "19.43193200",
		"longitude": "-99.13317000",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 63,
		"iso": "MZ",
		"name": "Мозамбик",
		"original_name": "Moçambique",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-25.53200300",
		"longitude": "32.45068700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 28,
		"iso": "MD",
		"name": "Молдова",
		"original_name": "Republica Moldova",
		"is_european_union": "0",
		"order": 5,
		"latitude": "47.02467200",
		"longitude": "28.83233600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 73,
		"iso": "MC",
		"name": "Монако",
		"original_name": "Monaco",
		"is_european_union": "0",
		"order": 5,
		"latitude": "43.73285400",
		"longitude": "7.41753300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 104,
		"iso": "MN",
		"name": "Монголия",
		"original_name": "Mongolia",
		"is_european_union": "0",
		"order": 5,
		"latitude": "47.92214800",
		"longitude": "106.91766500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 54,
		"iso": "NL",
		"name": "Нидерланды",
		"original_name": "Nederland",
		"is_european_union": "1",
		"order": 5,
		"latitude": "52.37308500",
		"longitude": "4.89327600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 37,
		"iso": "NZ",
		"name": "Новая Зеландия",
		"original_name": "New Zealand",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-41.28948000",
		"longitude": "174.77694900",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 47,
		"iso": "NO",
		"name": "Норвегия",
		"original_name": "Norge",
		"is_european_union": "0",
		"order": 5,
		"latitude": "59.91228700",
		"longitude": "10.74999500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 103,
		"iso": "AE",
		"name": "Объединенные Арабские Эмираты",
		"original_name": "الإمارات العربية المتحدة",
		"is_european_union": "0",
		"order": 5,
		"latitude": "24.46918400",
		"longitude": "54.37173600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 55,
		"iso": "IM",
		"name": "Остров Мэн",
		"original_name": "Isle of Man",
		"is_european_union": "0",
		"order": 5,
		"latitude": "54.15027800",
		"longitude": "-4.48095800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 66,
		"iso": "PK",
		"name": "Пакистан",
		"original_name": "Pakistan",
		"is_european_union": "0",
		"order": 5,
		"latitude": "33.70767900",
		"longitude": "73.07046500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 102,
		"iso": "PE",
		"name": "Перу",
		"original_name": "Perú",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-12.05615700",
		"longitude": "-77.02679000",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 7,
		"iso": "PL",
		"name": "Польша",
		"original_name": "Polska",
		"is_european_union": "1",
		"order": 5,
		"latitude": "52.22862300",
		"longitude": "21.01227000",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 49,
		"iso": "PT",
		"name": "Португалия",
		"original_name": "Portugal",
		"is_european_union": "1",
		"order": 5,
		"latitude": "38.72569600",
		"longitude": "-9.15024800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 95,
		"iso": "RE",
		"name": "Реюньон",
		"original_name": "Reunion",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-20.89265200",
		"longitude": "55.47103200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 38,
		"iso": "RO",
		"name": "Румыния",
		"original_name": "România",
		"is_european_union": "1",
		"order": 5,
		"latitude": "44.43428800",
		"longitude": "26.10297600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 50,
		"iso": "SV",
		"name": "Сальвадор",
		"original_name": "Salvador",
		"is_european_union": "0",
		"order": 5,
		"latitude": "13.69965800",
		"longitude": "-89.20680400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 109,
		"iso": "RS",
		"name": "Сербия",
		"original_name": "Република Србија",
		"is_european_union": "0",
		"order": 5,
		"latitude": "44.81309900",
		"longitude": "20.46325400",
		"date_created": "2016-09-21 16:15:05",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 94,
		"iso": "SG",
		"name": "Сингапур",
		"original_name": "Singapore",
		"is_european_union": "0",
		"order": 5,
		"latitude": "1.29015300",
		"longitude": "103.85199300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 87,
		"iso": "SY",
		"name": "Сирия",
		"original_name": "سوريا",
		"is_european_union": "0",
		"order": 5,
		"latitude": "33.51655800",
		"longitude": "36.31707200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 67,
		"iso": "SK",
		"name": "Словакия",
		"original_name": "Slovensko",
		"is_european_union": "1",
		"order": 5,
		"latitude": "48.14924800",
		"longitude": "17.10698600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 62,
		"iso": "SI",
		"name": "Словения",
		"original_name": "Slovenija",
		"is_european_union": "1",
		"order": 5,
		"latitude": "46.05061500",
		"longitude": "14.50281500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 4,
		"iso": "GB",
		"name": "Соединенное Королевство",
		"original_name": "United Kingdom",
		"is_european_union": "1",
		"order": 5,
		"latitude": "51.50606100",
		"longitude": "-0.12696000",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 2,
		"iso": "US",
		"name": "Соединенные Штаты",
		"original_name": "USA",
		"is_european_union": "0",
		"order": 5,
		"latitude": "38.89204800",
		"longitude": "-77.03198700",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 86,
		"iso": "SR",
		"name": "Суринам",
		"original_name": "Suriname",
		"is_european_union": "0",
		"order": 5,
		"latitude": "5.82030900",
		"longitude": "-55.16541600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 21,
		"iso": "TJ",
		"name": "Таджикистан",
		"original_name": "Tajikistan",
		"is_european_union": "0",
		"order": 5,
		"latitude": "38.55850600",
		"longitude": "68.76341200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 88,
		"iso": "TH",
		"name": "Таиланд",
		"original_name": "ประเทศไทย",
		"is_european_union": "0",
		"order": 5,
		"latitude": "13.75335200",
		"longitude": "100.50482600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 85,
		"iso": "TW",
		"name": "Тайвань",
		"original_name": "台湾",
		"is_european_union": "0",
		"order": 5,
		"latitude": "25.02232600",
		"longitude": "121.53512500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 77,
		"iso": "TC",
		"name": "Тёркс и Кайкос",
		"original_name": "Turks and Caicos",
		"is_european_union": "0",
		"order": 5,
		"latitude": "21.46361900",
		"longitude": "-71.13898100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 89,
		"iso": "TN",
		"name": "Тунис",
		"original_name": "تونس",
		"is_european_union": "0",
		"order": 5,
		"latitude": "36.80000400",
		"longitude": "10.18269100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 64,
		"iso": "TM",
		"name": "Туркмения",
		"original_name": "Turkmenistan",
		"is_european_union": "0",
		"order": 5,
		"latitude": "37.93519000",
		"longitude": "58.37892300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 32,
		"iso": "TR",
		"name": "Турция",
		"original_name": "Türkiye",
		"is_european_union": "0",
		"order": 5,
		"latitude": "41.00892500",
		"longitude": "28.96711100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 69,
		"iso": "UG",
		"name": "Уганда",
		"original_name": "Uganda",
		"is_european_union": "0",
		"order": 5,
		"latitude": "0.32539900",
		"longitude": "32.58701600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 15,
		"iso": "UZ",
		"name": "Узбекистан",
		"original_name": "Ўзбекистон",
		"is_european_union": "0",
		"order": 5,
		"latitude": "41.31114400",
		"longitude": "69.27966500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 41,
		"iso": "FI",
		"name": "Финляндия",
		"original_name": "Suomi",
		"is_european_union": "1",
		"order": 5,
		"latitude": "60.22600300",
		"longitude": "24.99294600",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 12,
		"iso": "FR",
		"name": "Франция",
		"original_name": "France",
		"is_european_union": "1",
		"order": 5,
		"latitude": "48.85692900",
		"longitude": "2.34119800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 53,
		"iso": "HR",
		"name": "Хорватия",
		"original_name": "Hrvatska",
		"is_european_union": "1",
		"order": 5,
		"latitude": "45.80723700",
		"longitude": "15.96757200",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 107,
		"iso": "ME",
		"name": "Черногория",
		"original_name": "Црна Гора",
		"is_european_union": "0",
		"order": 5,
		"latitude": "42.43542600",
		"longitude": "19.26389500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 40,
		"iso": "CZ",
		"name": "Чешская Республика",
		"original_name": "Česká republika",
		"is_european_union": "1",
		"order": 5,
		"latitude": "50.07907900",
		"longitude": "14.43321400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 93,
		"iso": "CL",
		"name": "Чили",
		"original_name": "Chile",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-33.43721900",
		"longitude": "-70.65001800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 43,
		"iso": "CH",
		"name": "Швейцария",
		"original_name": "Schweiz",
		"is_european_union": "0",
		"order": 5,
		"latitude": "46.94842700",
		"longitude": "7.44045800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 36,
		"iso": "SE",
		"name": "Швеция",
		"original_name": "Sverige",
		"is_european_union": "1",
		"order": 5,
		"latitude": "59.33232700",
		"longitude": "18.06292800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 92,
		"iso": "EC",
		"name": "Эквадор",
		"original_name": "Ecuador",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-0.20566200",
		"longitude": "-78.50873100",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 33,
		"iso": "EE",
		"name": "Эстония",
		"original_name": "Eesti",
		"is_european_union": "1",
		"order": 5,
		"latitude": "59.43733800",
		"longitude": "24.74523500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-12 14:05:55"
	},
	{
		"id": 91,
		"iso": "ZA",
		"name": "ЮАР",
		"original_name": "South Africa",
		"is_european_union": "0",
		"order": 5,
		"latitude": "-33.91908900",
		"longitude": "18.42198500",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 35,
		"iso": "KR",
		"name": "Южная Корея",
		"original_name": "대한민국",
		"is_european_union": "0",
		"order": 5,
		"latitude": "37.51502000",
		"longitude": "127.01646300",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2017-09-08 15:14:09"
	},
	{
		"id": 90,
		"iso": "JM",
		"name": "Ямайка",
		"original_name": "Jamaica",
		"is_european_union": "0",
		"order": 5,
		"latitude": "17.97092400",
		"longitude": "-76.78826900",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 6,
		"iso": "JP",
		"name": "Япония",
		"original_name": "日本",
		"is_european_union": "0",
		"order": 5,
		"latitude": "35.66965200",
		"longitude": "139.82485800",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	},
	{
		"id": 106,
		"iso": "EU",
		"name": "Европа",
		"original_name": "Europe",
		"is_european_union": "0",
		"order": 6,
		"latitude": "50.84438800",
		"longitude": "4.35608400",
		"date_created": "2016-07-19 10:52:18",
		"date_updated": "2016-10-04 12:39:06"
	}
];


//////////////////
// WEBPACK FOOTER
// ./configs/countries.config.json
// module id = 195
// module chunks = 0